import { connect } from 'react-redux';
import RequestRefreshDialog from './RequestRefreshDialog';
import * as requestsActions from '../../redux/actions/requests.actions';
import { REQUEST_REFRESH_DIALOG_ACTION_REFRESH } from '../../redux/helpers/requestRefreshDialog.helper';

const mapStateToProps = state => {
  const { requestRefreshDialog } = state.requests;

  return {
    open: requestRefreshDialog.isOpen,
    title: requestRefreshDialog.title,
    message: requestRefreshDialog.message,
    buttonText: requestRefreshDialog.buttonText,
    buttonAction: requestRefreshDialog.buttonAction,
    hideCancel: requestRefreshDialog.hideCancel,
    conflicts: requestRefreshDialog.conflicts,
    requestId: state.requests.request?.id,
  };
};

const mapDispatchToProps = {
  partialRefreshRequestAfterUpdate: requestsActions.partialRefreshRequestAfterUpdate,
  clearRequestRefreshDialog: requestsActions.clearRequestRefreshDialog,
};

export const mergeProps = (stateProps, dispatchProps) => ({
  open: stateProps.open,
  title: stateProps.title,
  message: stateProps.message,
  buttonText: stateProps.buttonText,
  hideCancel: stateProps.hideCancel,
  conflicts: stateProps.conflicts,
  onConfirm: confirmed => {
    dispatchProps.clearRequestRefreshDialog();

    if (confirmed && stateProps.buttonAction === REQUEST_REFRESH_DIALOG_ACTION_REFRESH) {
      dispatchProps.partialRefreshRequestAfterUpdate(stateProps.requestId);
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RequestRefreshDialog);
